import Real from '@/views/webpc/CashierDesk/RealApp/Real'

// 定义路由路径数列表
export default [{
  path: '/real',
  name: '实时收银',
  component: Real
}]



// WEBPACK FOOTER //
// ./src/views/webpc/CashierDesk/RealApp/routers/index.js